import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { errorFraudMsg } from 'src/app/enums/errorMsg/fraud.enum';
import { SignInError } from 'src/app/enums/errorMsg/signIn.enum';
import { RegisterUserModel } from 'src/app/models/registeruser.model';
import { AuthService } from 'src/app/services/auth/auth.service';
import { RedirectToMainSiteService } from 'src/app/services/redirectToMainSite/redirect-to-main-site.service';
import { StoragePermissionService } from 'src/app/services/storagePermission/storage-permission.service';
import { Language } from 'src/app/tools/language/language';
import { dataText } from './dataText';

@Component({
  selector: 'app-modal-confirmation',
  templateUrl: './modal-confirmation.component.html',
  styleUrls: ['./modal-confirmation.component.scss']
})
export class ModalConfirmationComponent implements OnInit {
  user: RegisterUserModel;
  lang: any = Language.currentLanguage.lenid;
  title: string;
  text: string;
  buttonTitle: string;

  constructor(
    private _authService: AuthService,
    private _storageService: StoragePermissionService,
    private _redirectToMainSite: RedirectToMainSiteService,
    private _snackBar: MatSnackBar,
    public dialogRef: MatDialogRef<ModalConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit(): void {
    if (this.lang === 'es') {
      this.title = dataText.es.title;
      this.text = dataText.es.text;
      this.buttonTitle = dataText.es.buttonTitle;
    } else if (this.lang === 'en') {
      this.title = dataText.en.title;
      this.text = dataText.en.text;
      this.buttonTitle = dataText.en.buttonTitle;
    } else if (this.lang === 'pt') {
      this.title = dataText.pt.title;
      this.text = dataText.pt.text;
      this.buttonTitle = dataText.pt.buttonTitle;
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  redirectToParentSite(): any {
    const expireToken = String(this._storageService.getExpireToken());
    const accessToken = this._storageService.getToken();
    const { cartId, usrEmail } = this.data;
    this._authService.singIn(usrEmail, accessToken, expireToken, cartId).subscribe(
      (response) => {
        let { code, data } = response;
        if (code === 201) {
          if (data && data.hash) {
            this._storageService.setUserHash(data.hash);
            this._redirectToMainSite.siteRedirect(data.hash);
          }
        }
      },
      (error) => {
        this.errorLoginSnackbar(error);
      }
    );
  }

  errorLoginSnackbar(signIn: boolean = false) {
    let errorMsg = signIn ? SignInError[this.lang] : errorFraudMsg[this.lang];
    let snackError = this._snackBar.open(errorMsg, 'OK', {
      duration: 8000
    });
    snackError.onAction().subscribe(() => {
      this._redirectToMainSite.errorRedirect();
    });
    snackError.afterDismissed().subscribe(() => {
      this._redirectToMainSite.errorRedirect();
    });
  }
}
